import {GLTranslate, useThemedStylesWithBreaks} from 'notability-services-common-frontend'
import {loginStyles} from './LoginStyles'

export function PolicyAndTermsReminder() {
  const s = useThemedStylesWithBreaks(loginStyles)
  return (
    <span style={s.tocAgreement}>
      <GLTranslate i18nKey={'continuingAgreesToPolicies'}>
        By tapping Continue, you agree to our
        <a href="https://notability.com/terms" target="_blank" rel="noreferrer" style={s.tocLink}>
          Terms and Conditions
        </a>
        and our
        <a href="https://notability.com/privacy" target="_blank" rel="noreferrer" style={s.tocLink}>
          Privacy Policy
        </a>
        .
      </GLTranslate>
    </span>
  )
}
